import type { ReviewBoostSetupReadiness } from "./reputation/views/ReviewBoostSetupGuide";

export type ReviewBoostV3GoogleState =
  | "unknown_connection"
  | "needs_connection"
  | "unknown_locations"
  | "needs_location"
  | "ready";

/** Never show Google as usable until both its connection and an internal location binding are verified. */
export function reviewBoostV3GoogleState(readiness?: ReviewBoostSetupReadiness): ReviewBoostV3GoogleState {
  if (!readiness?.connectionVerified || !readiness.connection) return "unknown_connection";
  if (readiness.connection.status !== "connected") return "needs_connection";
  if (!readiness.locationsVerified || !Array.isArray(readiness.locations)) return "unknown_locations";
  if (!readiness.locations.some(location =>
    typeof location.location_id === "string" && location.location_id.trim().length > 0
  )) return "needs_location";
  return "ready";
}
